import axios from 'axios';
import { signOut } from "./index";

const instance = axios.create({
    baseURL: process.env.REACT_APP_SERVER_URL,
    responseType: 'json'
});

instance.interceptors.request.use(
    async config => {
        const token = localStorage.getItem("login_token");
        if (token) {
            config.headers.Authorization = "Bearer " + token
        }
        return config
    },
    error => {
        return Promise.reject(error)
    }
);

instance.interceptors.response.use(
    (response) => {
        if (response.status === 401) {
            signOut();
            return Promise.reject("You are not authorized");
        }
        return response;
    },
    (error) => {
        if (error.response && error.response.status === 403) {
            signOut();
        }
        return Promise.reject(error.message);
    }
);



export const api = instance;